var map = {
	"./angle-down.svg": "f13c",
	"./angle-left.svg": "fe0d",
	"./angle-right.svg": "9134",
	"./checkmark-solid.svg": "ae70",
	"./checkmark.svg": "4148",
	"./close-solid.svg": "0536",
	"./close.svg": "65e7",
	"./delete-circle.svg": "b5e7",
	"./digital-risks-logo.svg": "6b34",
	"./info.svg": "6d26",
	"./loading.svg": "5d87"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3fc8";